export default "__VITE_ASSET__DDFZZ7yX__"